import React, { useState, useEffect } from 'react';
import { Smile, RefreshCw, Sparkles } from 'lucide-react';
import apiService from '../services/api';

const DadJokesPage = () => {
  const [joke, setJoke] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadJoke();
  }, []);

  const loadJoke = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.getDadJoke();
      setJoke(response.joke);
    } catch (err) {
      console.error('Error loading joke:', err);
      setError('Failed to load joke. Try again!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 dark:from-purple-950 dark:via-pink-950 dark:to-blue-950 flex items-center justify-center p-4 transition-colors">
      <div className="max-w-2xl w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <Sparkles className="h-8 w-8 text-yellow-500 dark:text-yellow-400 animate-pulse" />
            <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 dark:from-purple-400 dark:to-pink-400 mx-3">
              Hello Diana!
            </h1>
            <Sparkles className="h-8 w-8 text-yellow-500 dark:text-yellow-400 animate-pulse" />
          </div>
          <p className="text-lg text-gray-600 dark:text-gray-300">Here's a dad joke just for you!</p>
        </div>

        {/* Joke Card */}
        <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 md:p-12 mb-6 transform transition-all hover:scale-105">
          <div className="flex justify-center mb-6">
            <div className="bg-gradient-to-r from-purple-500 to-pink-500 dark:from-purple-600 dark:to-pink-600 rounded-full p-4">
              <Smile className="h-12 w-12 text-white" />
            </div>
          </div>

          {loading ? (
            <div className="text-center py-12">
              <RefreshCw className="h-12 w-12 animate-spin mx-auto text-purple-600 dark:text-purple-400 mb-4" />
              <p className="text-gray-600 dark:text-gray-300">Loading joke...</p>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <p className="text-red-600 dark:text-red-400 text-lg">{error}</p>
            </div>
          ) : (
            <div className="text-center">
              <p className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 leading-relaxed font-medium">
                {joke}
              </p>
            </div>
          )}
        </div>

        {/* Refresh Button */}
        <div className="flex justify-center">
          <button
            onClick={loadJoke}
            disabled={loading}
            className="group relative inline-flex items-center px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl transform transition-all hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
          >
            <RefreshCw className={`h-6 w-6 mr-3 ${loading ? 'animate-spin' : 'group-hover:rotate-180 transition-transform duration-500'}`} />
            {loading ? 'Loading...' : 'Another One!'}
          </button>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Powered by AI dad joke technology
          </p>
        </div>
      </div>
    </div>
  );
};

export default DadJokesPage;
